import { FormMetaData } from "@/store/formCreator/types";

export const decodeFormMetaData = (metaDataCoded: string): FormMetaData | null => 
    metaDataCoded && JSON.parse(Buffer.from(metaDataCoded, 'base64').toString('utf8'));
